import { useEffect, useState } from "react";
import { API } from "../data/siteData";

export default function useLeadNotes(selectedLeadId) {
  const [notes, setNotes] = useState([]);
  const [state, setState] = useState("idle");

  useEffect(() => {
    if (!selectedLeadId) {
      setNotes([]);
      return undefined;
    }
    let active = true;
    fetch(`${API}/admin/leads/${selectedLeadId}/notes`, { credentials: "include" })
      .then((response) => response.ok ? response.json() : [])
      .then((records) => {
        if (active) setNotes(records);
      });
    return () => {
      active = false;
    };
  }, [selectedLeadId]);

  const addNote = async (note) => {
    if (!selectedLeadId || !note.trim()) return false;
    setState("loading");
    const response = await fetch(`${API}/admin/leads/${selectedLeadId}/notes`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: note.trim() }),
    });
    if (!response.ok) {
      setState("error");
      return false;
    }
    const created = await response.json();
    setNotes((currentNotes) => [created, ...currentNotes]);
    setState("idle");
    return true;
  };

  return { addNote, notes, state };
}